import { useGetApiAccountMeQuery } from 'shared/api/gsp';

export const useHideSchoolLinks = () =>
  !useGetApiAccountMeQuery().data?.featureFlags.includes('ShowSchoolLinks');
